export default {
  /**
   * Estado das permissões do usuário.
   * @property {Array} permissions,
   */
  permissions: [],
};
